"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRgbValue = getRgbValue;
exports.toRgb = toRgb;
exports.toHex = toHex;
exports.getOpacity = getOpacity;
exports.getRgbaValue = getRgbaValue;
exports.getColorFromRgbValue = getColorFromRgbValue;
exports.darken = darken;
exports.lighten = lighten;
exports.fade = fade;
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var hexReg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
var rgbReg = /^(rgb|rgba|RGB|RGBA)/;
var rgbaReg = /^(rgba|RGBA)/;
/**
 * @description Get the rgb value of the color
 * @param {String} color Hex or rgb/rgba color
 * @return {Array} Rgb value of the color
 */

function getRgbValue(color) {
  if (!color) {
    console.error('GetRgbValue Missing parameters!');
    return;
  }

  var isHex = hexReg.test(color);
  var isRgb = rgbReg.test(color);

  if (!isHex && !isRgb) {
    console.error('Incorrect color type!');
    return;
  }

  var lowerColor = color.toLowerCase();
  if (isHex) return getRgbValueFromHex(lowerColor);
  if (isRgb) return getRgbValueFromRgb(lowerColor);
}
/**
 * @description Get the rgb value of the hex color
 * @param {String} color Hex color
 * @return {Array} Rgb value of the color
 */


function getRgbValueFromHex(color) {
  color = color.replace('#', '');
  if (color.length === 3) color = Array.from(color).map(function (hexNum) {
    return hexNum + hexNum;
  }).join('');
  color = color.split('');
  return new Array(3).fill(0).map(function (t, i) {
    return parseInt("0x".concat(color[i * 2]).concat(color[i * 2 + 1]));
  });
}
/**
 * @description Get the rgb value of the rgb/rgba color
 * @param {String} color Hex color
 * @return {Array} Rgb value of the color
 */


function getRgbValueFromRgb(color) {
  return color.replace(/rgb\(|rgba\(|\)/g, '').split(',').slice(0, 3).map(function (n) {
    return parseInt(n);
  });
}
/**
 * @description Convert color to rgb/rgba color
 * @param {String} color   Hex or rgb/rgba color
 * @param {Number} opacity The opacity of color
 * @return {String} Rgb/rgba color
 */


function toRgb(color, opacity) {
  if (!color) {
    console.error('ToRgb Missing parameters!');
    return;
  }

  var rgbValue = getRgbValue(color);
  var addOpacity = typeof opacity === 'number';
  if (addOpacity) return 'rgba(' + rgbValue.join(',') + ",".concat(opacity, ")");
  return 'rgb(' + rgbValue.join(',') + ')';
}
/**
 * @description Convert color to hex color
 * @param {String} color Hex or rgb/rgba color
 * @return {String} Hex color
 */


function toHex(color) {
  if (!color) {
    console.error('ToHex Missing parameters!');
    return;
  }

  color = color.toLowerCase();
  if (hexReg.test(color)) return color;

  if (!rgbReg.test(color)) {
    console.warn('Incorrect color type!');
    return;
  }

  color = getRgbValue(color);
  return '#' + color.map(function (n) {
    return Number(n).toString(16);
  }).map(function (n) {
    return n === '0' ? '00' : n;
  }).join('');
}
/**
 * @description Get the opacity of color
 * @param {String} color Hex or rgb/rgba color
 * @return {Number} Color opacity
 */


function getOpacity(color) {
  if (!color) {
    console.error('GetOpacity Missing parameters!');
    return;
  }

  var isRgba = rgbaReg.test(color);
  color = color.toLowerCase();
  if (!isRgba) return 1;
  return Number(color.split(',').slice(-1)[0].replace(/[)|\s]/g, ''));
}
/**
 * @description Get the rgba value of the color
 * @param {String} color Hex or rgb/rgba color
 * @return {Array} Rgba value of the color
 */


function getRgbaValue(color) {
  if (!color) {
    console.error('GetRgbaValue Missing parameters!');
    return;
  }

  var colorValue = getRgbValue(color);
  colorValue.push(getOpacity(color));
  return colorValue;
}
/**
 * @description Get Color from rgb value
 * @param {Array} value Rgb color value
 * @return {String} Rgb / rgba color
 */


function getColorFromRgbValue(value) {
  if (!value) {
    console.error('GetColorFromRgbValue Missing parameters!');
    return;
  }

  var valueLength = value.length;

  if (valueLength !== 3 && valueLength !== 4) {
    console.error('value is illegal!');
    return;
  }

  var color = valueLength === 3 ? 'rgb(' : 'rgba(';
  color += value.join(',') + ')';
  return color;
}
/**
 * @description Deepen color
 * @param {String} color Hex or rgb/rgba color
 * @return {Number} Percent of Deepen
 * @return {String} Rgba color
 */


function darken(color, percent) {
  if (!color) {
    console.error('Darken Missing parameters!');
    return;
  }

  var rgbaValue = getRgbaValue(color);
  if (!rgbaValue) return;
  rgbaValue = rgbaValue.map(function (v, i) {
    return i === 3 ? v : v - 25 * percent;
  }).map(function (v) {
    return v < 0 ? 0 : v;
  });
  return getColorFromRgbValue(rgbaValue);
}
/**
 * @description Brighten color
 * @param {String} color Hex or rgb/rgba color
 * @return {Number} Percent of brighten
 * @return {String} Rgba color
 */


function lighten(color, percent) {
  if (!color) {
    console.error('Lighten Missing parameters!');
    return;
  }

  var rgbaValue = getRgbaValue(color);
  if (!rgbaValue) return;
  rgbaValue = rgbaValue.map(function (v, i) {
    return i === 3 ? v : v + 25 * percent;
  }).map(function (v) {
    return v > 255 ? 255 : v;
  });
  return getColorFromRgbValue(rgbaValue);
}
/**
 * @description Adjust color opacity
 * @param {String} color   Hex or rgb/rgba color
 * @param {Number} Percent of opacity
 * @return {String} Rgba color
 */


function fade(color) {
  var percent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

  if (!color) {
    console.error('Fade Missing parameters!');
    return;
  }

  var rgbValue = getRgbValue(color);
  var rgbaValue = [].concat(_toConsumableArray(rgbValue), [percent / 100]);
  return getColorFromRgbValue(rgbaValue);
}

var _default = {
  darken: darken,
  lighten: lighten,
  fade: fade,
  toHex: toHex,
  toRgb: toRgb,
  getOpacity: getOpacity,
  getRgbValue: getRgbValue,
  getRgbaValue: getRgbaValue,
  getColorFromRgbValue: getColorFromRgbValue
};
exports["default"] = _default;